import styled, { css } from 'styled-components';

export const ModalContent = styled.div(
  ({ theme }) => css`
    padding: ${theme.sz.s12};
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s6};
    text-align: center;

    @media (max-width: ${theme.sz.md}) {
      padding: ${theme.sz.s8};
      gap: ${theme.sz.s4};
    }
  `,
);

export const Image = styled.img(
  ({ theme }) => css`
    width: ${theme.sz.s68};

    @media (max-width: ${theme.sz.md}) {
      width: ${theme.sz.s48};
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.accent.xxl};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.accent.xl};
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    padding-bottom: ${theme.sz.s6};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
      padding-bottom: ${theme.sz.s4};
    }
  `,
);
